import { emitDedupedToast } from '@/utils/common/toastBridge';

/** Spec §3.3 verbatim copy. 503 shares 502's transient-gateway message. */
export const GATEWAY_ERROR_MESSAGES: { 502: string; 503: string; 504: string } = {
  502: 'Server is temporarily unavailable. Please try again in a moment.',
  503: 'Server is temporarily unavailable. Please try again in a moment.',
  504: 'The server took too long to respond. Please try again.',
};

const isGatewayStatus = (status: number): status is 502 | 503 | 504 =>
  status === 502 || status === 503 || status === 504;

/** One toast per status-class per 10s window, via the global bridge. No-op for non-gateway statuses. */
export const notifyGatewayError = (status: number): void => {
  if (!isGatewayStatus(status)) return;
  emitDedupedToast(`gateway-${status}`, { type: 'error', message: GATEWAY_ERROR_MESSAGES[status] });
};
